(function () {
  var selectors = {
    root: '[data-sussi-the-look-root]',
    tab: '[data-collection-id]',
    trigger: '[data-sussi-quick-view-trigger]',
    modal: '[data-sussi-quick-view-modal]',
    content: '[data-sussi-quick-view-content]'
  };

  var productCache = new Map();

  function ensureProductResources(template) {
    template.content.querySelectorAll('.section-main-product link[rel="stylesheet"], link[rel="stylesheet"][href*="modal.css"]').forEach(function (link) {
      var href = link.getAttribute('href');
      if (href && !document.querySelector('link[rel="stylesheet"][href="' + href + '"]')) {
        document.head.insertAdjacentHTML('beforeend', link.outerHTML);
      }
    });

    template.content.querySelectorAll('.section-main-product script[src]').forEach(function (script) {
      var src = script.getAttribute('src');
      if (!src || document.querySelector('script[src="' + src + '"]')) return;
      var nextScript = document.createElement('script');
      nextScript.src = src;
      nextScript.defer = true;
      document.head.appendChild(nextScript);
    });
  }

  function buildQuickViewContent(html, productUrl) {
    var template = document.createElement('template');
    template.innerHTML = html;
    var source = template.content.querySelector('.quickbuy-content');
    if (!source) {
      throw new Error('Product quick view content was not found.');
    }

    var content = source.cloneNode(true);

    content.querySelectorAll('.more').forEach(function (link) {
      link.href = productUrl;
    });
    content.querySelectorAll('.product-title').forEach(function (title) {
      title.innerHTML = '<a href="' + productUrl + '">' + title.innerHTML + '</a>';
    });
    content.querySelectorAll('.show-gallery').forEach(function (link) {
      link.classList.remove('show-gallery');
      link.href = productUrl;
    });
    content.querySelectorAll('.not-in-quickbuy').forEach(function (element) {
      element.remove();
    });
    content.querySelectorAll('.only-in-quickbuy').forEach(function (element) {
      element.classList.remove('only-in-quickbuy');
    });
    content.querySelectorAll('.sticky-content-container').forEach(function (element) {
      element.classList.remove('sticky-content-container');
    });
    content.querySelectorAll('pickup-availability, noscript').forEach(function (element) {
      element.remove();
    });
    content.querySelectorAll('variant-picker[data-update-url="true"]').forEach(function (picker) {
      picker.dataset.updateUrl = 'false';
    });
    content.querySelectorAll('.media-gallery .main-image carousel-slider').forEach(function (element) {
      element.classList.remove('mobile-only');
    });
    content.querySelectorAll('.product-media-collage').forEach(function (element) {
      element.remove();
    });
    content.querySelectorAll('.media-gallery .thumbnails').forEach(function (element) {
      element.classList.remove('mobile-only');
    });
    [
      'media-gallery--layout-carousel-under',
      'media-gallery--layout-columns-1',
      'media-gallery--layout-columns-2',
      'media-gallery--layout-collage-1',
      'media-gallery--layout-collage-2'
    ].forEach(function (layoutClass) {
      content.querySelectorAll('.' + layoutClass).forEach(function (element) {
        element.classList.remove(layoutClass);
        element.classList.add('media-gallery--layout-carousel-beside');
      });
    });

    ensureProductResources(template);
    return content;
  }

  function fetchQuickView(productUrl) {
    if (!productCache.has(productUrl)) {
      productCache.set(productUrl, fetch(productUrl, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Product request failed with status ' + response.status + '.');
          }
          return response.text();
        })
        .then(function (html) {
          return buildQuickViewContent(html, productUrl);
        }));
    }
    return productCache.get(productUrl).then(function (content) {
      return content.cloneNode(true);
    });
  }

  function addEtaDays(startDate, days, mode) {
    var result = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
    var remaining = Math.max(0, Number(days) || 0);

    while (remaining > 0) {
      result.setDate(result.getDate() + 1);
      if (mode !== 'business' || (result.getDay() !== 0 && result.getDay() !== 6)) {
        remaining -= 1;
      }
    }

    return result;
  }

  function formatEtaDate(date) {
    var locale = document.documentElement.lang || navigator.language || 'en';
    return new Intl.DateTimeFormat(locale, {
      month: 'short',
      day: 'numeric'
    }).format(date);
  }

  function formatEtaDateAttribute(date) {
    var month = String(date.getMonth() + 1).padStart(2, '0');
    var day = String(date.getDate()).padStart(2, '0');
    return date.getFullYear() + '-' + month + '-' + day;
  }

  function refreshEta(root) {
    root.querySelectorAll('[data-pdp-eta]').forEach(function (eta) {
      var mode = eta.dataset.dayMode || 'calendar';
      var processingDays = Number(eta.dataset.processingDays) || 0;
      var shippingDays = Number(eta.dataset.shippingDays) || 0;
      var target = eta.querySelector('[data-pdp-eta-date]');

      if (!target || processingDays + shippingDays <= 0) return;

      var processingDate = addEtaDays(new Date(), processingDays, mode);
      var arrivalDate = addEtaDays(processingDate, shippingDays, mode);
      target.dateTime = formatEtaDateAttribute(arrivalDate);
      target.textContent = formatEtaDate(arrivalDate);
    });
  }

  function initInjectedQuickView(root) {
    refreshEta(root);
    if (window.SussiPdpWishlist && typeof window.SussiPdpWishlist.init === 'function') {
      window.SussiPdpWishlist.init(root);
    }
  }

  function alignSelectedTab(tab) {
    if (!tab.classList.contains('look-active')) return;

    var tabSwiper = tab.closest('.nk-the-look__swiper');
    var slide = tab.closest('.swiper-slide');
    if (!tabSwiper || !slide) return;

    var slides = Array.prototype.slice.call(tabSwiper.querySelectorAll('.swiper-wrapper > .swiper-slide'));
    var index = slides.indexOf(slide);
    var swiper = tabSwiper.swiper;
    var isMobile = window.matchMedia('(max-width: 767px)').matches;
    if (index < 0 || !isMobile) return;

    var wrapper = tabSwiper.querySelector('.swiper-wrapper');
    if (wrapper) {
      var endPad = Math.max(0, (tabSwiper.clientWidth - slide.offsetWidth) / 2);
      tabSwiper.style.setProperty('--sussi-tab-end-pad', endPad + 'px');
    }

    if (index === 0) {
      tabSwiper.scrollTo({ left: 0, behavior: 'smooth' });
      return;
    }

    var tabSwiperRect = tabSwiper.getBoundingClientRect();
    var slideRect = slide.getBoundingClientRect();
    var centerDelta = (slideRect.left + (slideRect.width / 2)) - (tabSwiperRect.left + (tabSwiperRect.width / 2));
    var targetLeft = tabSwiper.scrollLeft + centerDelta;
    tabSwiper.scrollTo({ left: Math.max(0, targetLeft), behavior: 'smooth' });

    if (swiper) {
      swiper.activeIndex = index;
      if (typeof swiper.updateSlidesClasses === 'function') swiper.updateSlidesClasses();
    }
  }

  function scheduleSelectedTabAlign(tab) {
    window.requestAnimationFrame(function () {
      alignSelectedTab(tab);
    });
    window.setTimeout(function () {
      alignSelectedTab(tab);
    }, 120);
    window.setTimeout(function () {
      alignSelectedTab(tab);
    }, 360);
    window.setTimeout(function () {
      alignSelectedTab(tab);
    }, 720);
    window.setTimeout(function () {
      alignSelectedTab(tab);
    }, 1080);
  }

  function hydrateCollection(root, collectionId) {
    if (!collectionId) return false;
    if (root.querySelector('#' + collectionId)) return false;

    var template = root.querySelector('template[data-sussi-look-template="' + collectionId + '"]');
    if (!template) return false;

    template.parentNode.insertBefore(template.content.cloneNode(true), template);
    template.remove();
    return true;
  }

  function openQuickView(trigger) {
    var root = trigger.closest(selectors.root);
    if (!root) return;

    var modal = root.querySelector(selectors.modal);
    var content = root.querySelector(selectors.content);
    var productUrl = trigger.dataset.productUrl || trigger.getAttribute('href');
    if (!modal || !content || !productUrl) return;

    content.innerHTML = '<div class="sussi-quick-view-modal__loading"><div class="loading-spinner"></div></div>';
    modal.removeAttribute('aria-hidden');
    modal.style.removeProperty('display');
    modal.style.removeProperty('visibility');
    modal.style.removeProperty('pointer-events');

    if (typeof modal.open === 'function') {
      modal.open(trigger);
    } else {
      modal.setAttribute('open', '');
    }
    modal.setAttribute('aria-hidden', 'false');

    fetchQuickView(productUrl)
      .then(function (quickViewContent) {
        content.innerHTML = '';
        content.appendChild(quickViewContent);
        initInjectedQuickView(content);
      })
      .catch(function () {
        content.innerHTML = '<div class="sussi-quick-view-modal__error"><a href="' + productUrl + '">View product details</a></div>';
      });
  }

  function init(container) {
    (container || document).querySelectorAll(selectors.root).forEach(function (root) {
      if (root.dataset.sussiQuickViewReady === 'true') return;
      root.addEventListener('click', function (event) {
        var trigger = event.target.closest(selectors.trigger);
        if (!trigger || !root.contains(trigger)) return;
        event.preventDefault();
        event.stopPropagation();
        openQuickView(trigger);
      }, true);

      root.addEventListener('click', function (event) {
        var tab = event.target.closest(selectors.tab);
        if (tab && root.contains(tab)) {
          if (hydrateCollection(root, tab.getAttribute('data-collection-id'))) {
            tab.classList.remove('look-active');
            tab.click();
            return;
          }
          scheduleSelectedTabAlign(tab);
          return;
        }

        var closeButton = event.target.closest('.sussi-quick-view-modal__close');
        if (closeButton && root.contains(closeButton)) {
          var modal = closeButton.closest(selectors.modal);
          event.preventDefault();
          if (modal && typeof modal.close === 'function') {
            modal.close();
          } else if (modal) {
            modal.removeAttribute('open');
          }
          return;
        }
      });
      root.dataset.sussiQuickViewReady = 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
